import { Expose, Transform } from 'class-transformer';
import { DrupalIdentifier, DrupalNode } from '@nx-icilalune/drupal-types';

export class Client extends DrupalNode {
  public static readonly type = 'clients';

  @Transform(({ obj }) => {
    return obj?.attributes.field_client_start;
  })
  @Expose()
  startDate!: string;

  @Transform(({ obj }) => {
    return obj?.attributes.field_client_end;
  })
  @Expose()
  endDate!: string;

  @Transform(({ obj }) => {
    const endDateString: string | undefined = obj?.attributes.field_client_end;
    if (endDateString) {
      const endDateStringSplit = endDateString.split('-');
      const endDate = new Date(
        parseInt(endDateStringSplit[2]),
        parseInt(endDateStringSplit[1]) - 1,
        parseInt(endDateStringSplit[0])
      );
      return endDate.getTime();
    }
    return Number.MAX_VALUE;
  })
  @Expose()
  endDateTimestamp!: number;

  @Transform(({ obj }) => {
    return obj?.attributes?.field_short_name;
  })
  @Expose()
  field_short_name!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.body;
  })
  @Expose()
  override description!: string;

  @Transform(({ obj }) => {
    return obj?.relationships?.logo?.data || undefined;
  })
  @Expose()
  logo: DrupalIdentifier | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.domains?.data || undefined;
  })
  @Expose()
  domains!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.associated_projects?.data || undefined;
  })
  @Expose()
  associated!: DrupalIdentifier[];
}
